// Only videos created with the format selector opt into the new geometry.
export function videoFormat(model) {
  const d = model && model.video_dimensions;
  return d && Number(d.format_version) === 1 && ['16:9', '9:16'].includes(d.aspect_ratio) ? d.aspect_ratio : null;
}
export function setVideoFormat(model, ratio) {
  if (!['16:9', '9:16'].includes(ratio)) return;
  const portrait = ratio === '9:16';
  model.video_dimensions = { ...model.video_dimensions, format_version: 1, aspect_ratio: ratio,
    width: portrait ? 720 : 1280, height: portrait ? 1280 : 720 };
  model.aspect_ratio = ratio;
  model.dimension_percentage = portrait ? 1600 / 9 : 900 / 16;
}
